/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Convert_TimecodeInputs */



/**
* | output |
* | --- |
* | "Convert Timecode" |
*
* @param {Convert_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const convert_timecode = /** @type {((inputs?: Convert_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Convert_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Convertir le code temporel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcode konvertieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Convertire il codice temporale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразовать временной код")
	if (locale === "es") return /** @type {LocalizedString} */ ("Convertir código de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("转换时间码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードを変換")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Converter código de tempo")
	return /** @type {LocalizedString} */ ("Convert Timecode")
});